
		<ng-template #popoverBody>
			<ng-container
				*ngFor="let cluster of clusters"
			>
				{{ cluster.n }}: {{ cluster.endAt }}
			</ng-container>
		</ng-template>
		
		<div class="float-right">
			<source-selector></source-selector>
			&nbsp;&nbsp;
			<span
				class="badge badge-{{labelStatus}}"
				triggers="mouseenter:mouseleave"
				[sextant]="'cacheDate'"
				[ngbPopover]="popoverBody"
			>
				<i
					*ngIf="pause"
					class="fa fa-pause-circle"
					aria-hidden="true"
					[title]="'adminstat.support.cache_info.rebuilding paused now' | translate"
				></i>
				
				{{ endAt | dateFormat: 'DD.MM.YYYY HH:mm' }}
			</span>
		</div>
	